import { Textarea } from './textarea'
import { AIPurpleButton } from './ai-purple-button'
import { Clock, Loader2 } from 'lucide-react'
import { t } from '@lingui/core/macro'
import { useSessionStorage } from 'react-use'
import { useCallback, useEffect, useState } from 'react'

const PREV_SESSION_PROMPT_KEY = 'claravine-agent-previous-prompt'

export const PromptInput: React.FC<{
  prompt: string
  setPrompt: (value: string) => void
  isLoading: boolean
  onSubmit: () => void
}> = ({ prompt, setPrompt, isLoading, onSubmit }) => {
  const [prevPrompt, setPrevPrompt] = useSessionStorage(PREV_SESSION_PROMPT_KEY, '')
  const [isRestored, setIsRestored] = useState(false)

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const value = e.target.value
      setPrompt(value)

      if (value.trim()) {
        setPrevPrompt(value)
      } else {
        setPrevPrompt('')
      }

      if (isRestored) {
        setIsRestored(false)
      }
    },
    [setPrompt, setPrevPrompt, isRestored],
  )

  useEffect(() => {
    if (!!prevPrompt && prevPrompt !== prompt) {
      setPrompt(prevPrompt)
      setIsRestored(true)
    }
  }, [prevPrompt, prompt, setPrompt])

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        {isRestored && (
          <div className="flex items-center gap-1 text-xs justify-end text-cv-green-600 font-semibold">
            <Clock className="h-4 w-4" />
            {t`Previous prompt restored`}
          </div>
        )}
        <Textarea
          name="claravine-agent-prompt"
          placeholder={t`Describe what you'd like to generate...`}
          value={prompt || prevPrompt}
          onChange={handleChange}
          disabled={isLoading}
          className="min-h-[140px] text-base"
        />
      </div>
      <AIPurpleButton
        onClick={onSubmit}
        disabled={isLoading || !prompt.trim()}
        className="w-full py-3 text-base font-medium"
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            {t`Processing...`}
          </>
        ) : (
          'Generate'
        )}
      </AIPurpleButton>
    </div>
  )
}
